import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import ArrowButton from "../../components/common/ArrowButton";
import { getCaseList } from "../../backend/services/caseCatergories";
import { useLocation, useNavigate } from "react-router-dom";
import { addScrollRef, scrollToRef } from "../../backend/scrollToRef";
import { sanitizeHTML } from "../../utils/htmlSanitizer";

const CaseCard = ({
  title,
  text,
  buttonText,
  buttonLink,
  navigationState,
  opened,
  select,
  onSelectedRef,
}) => {
  const isLess = useMediaQuery({ query: `(max-width: 1100px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const isMedium = useMediaQuery({ query: `(max-width: 500px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 400px)` });
  const [isOpened, setOpened] = useState(opened);
  useEffect(() => {
    // console.log(title, opened);
    setOpened(opened);
  }, [opened]);

  const cardRef: React.Ref<HTMLDivElement> = useRef(null);
  const headerRef: React.Ref<HTMLDivElement> = useRef(null);
  useEffect(() => {
    addScrollRef(navigationState, cardRef, () => {
      select();
      setOpened(true);
    });
  }, [cardRef]);

  useEffect(() => {
    setOpened(opened);
    if (opened && cardRef.current) {
      onSelectedRef?.(cardRef); // Pass ref back to parent
    }
  }, [opened]);

  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.scrollTo === navigationState) {
      window.history.replaceState(null, "", window.location.href);
      scrollToRef(cardRef);
    }
  }, [location]);
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} ref={cardRef}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {isOpened && !isMobile && (
          <div
            style={{
              height: "100%",
              width: "var(--main-container-margin)",
              backgroundColor: "var(--olive)",
              marginLeft: "calc(0px - var(--main-container-margin))",
            }}
          />
        )}
        <div  
          style={{
            ...styles.closedCaseContainer,
          }}
          onClick={() => {
            select();
            setOpened(!isOpened);
          }}
        >
          <h3
            style={{
              ...styles.headerText,
              fontSize: isMobile ? "4.5vw" : isLess ? "2.2rem" : "3rem",
              padding: isSmall ? "1rem 0.5rem" : isMedium ? "1rem" : isMobile ? "1.5rem" : "2rem",
            }}
            ref={headerRef}
          >
            {title}
          </h3>
          <div style={styles.headerIconContainer}>
            <img
              src={"/assets/icons/plus.svg"}
              style={{
                width: isSmall ? "2rem" : isMedium ? "3rem" : isMobile ? "4rem" : "6rem",
                height: isSmall ? "2rem" : isMedium ? "3rem" : isMobile ? "4rem" : "6rem",
                transform: isOpened ? "rotate(45deg)" : "rotate(0deg)",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
            />
          </div>
        </div>
      </div>
      {isOpened && (
        <p
          style={{ ...styles.caseText, fontSize: isMobile ? "1.25rem" : "1.5rem" }}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(text) }}
        />
      )}
      {isOpened && (
        <ArrowButton
          text={buttonText}
          fontSize={isSmall ? "1rem" : isMedium ? "1rem" : isMobile ? "1.18rem" : "2rem"}
          external_link={buttonLink}
          iconColor="var(--white)"
          iconSize={isSmall ? "1rem" : isMobile ? "2rem" : "3rem"}
        />
      )}
    </div>
  );
};

const CaseCategories = () => {
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 450px)` });
  const [scrollTargetRef, setScrollTargetRef] = useState<React.RefObject<HTMLDivElement> | null>(
    null
  );

  const [selected, setSelected] = useState(-1);
  const cases = getCaseList();

  useEffect(() => {
    if (scrollTargetRef?.current) {
      scrollTargetRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setScrollTargetRef(null);
    }
  }, [scrollTargetRef]);

  return (
    <div style={styles.caseCategoriesWrapper}>
      <div
        style={{
          ...styles.caseCategoriesContainer,
          paddingTop: isSmall ? "3rem" : isMobile ? "4rem" : "5rem",
          paddingBottom: isSmall ? "3rem" : isMobile ? "4rem" : "5rem",
          gap: isSmall ? "3rem" : isMobile ? "4rem" : "5rem",
        }}
      >
        {cases.map((item, index) => (
          <CaseCard
            title={item.name}
            text={item.text}
            buttonText={item.buttonText}
            buttonLink={item.buttonLink}
            navigationState={item.navigationState}
            opened={index === selected}
            select={() => {
              setSelected(index);
            }}
            onSelectedRef={(ref) => setScrollTargetRef(ref)}
          />
        ))}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  caseCategoriesWrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    backgroundColor: "var(--white)",
  },
  caseCategoriesContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    padding: "2rem 0",
  },
  missionText: {
    fontSize: "1.2rem",
    lineHeight: "1.5",
    color: "var(--dark-grey)",
    margin: "0",
    maxWidth: "80%",
  },
  header: {
    fontSize: "5rem",
    fontWeight: "bold",
    color: "var(--black)",
  },
  missionCardContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "2rem",
  },
  bulletPoint: {
    width: "15px",
    height: "15px",
    marginTop: "0.85rem",
    backgroundColor: "var(--black)",
    flexShrink: 0,
  },
  missionCardDescription: {
    fontSize: "2rem",
    color: "var(--grey)",
  },
  closedCaseContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    border: "5px solid var(--olive)",
    width: "var(--main-container-width)",
    cursor:"pointer",
  },
  headerText: {
    fontWeight: "bold",
    width: "100%",
  },
  headerIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--olive   )",
    height: "100%",
    aspectRatio: 1,
  },
  caseText: {
    fontSize: "1.5rem",
    padding: "2rem 0rem",
    whiteSpace: "break-spaces",
  },
};

export default CaseCategories;
